import React from "react";

export default function favoritesGamesListTemplate () {
    return <div>Favorites Games List</div>;
};